import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { callcenterService } from '../../api/callcenterService';
import { Card, CardHeader, CardTitle, CardContent, CardFooter, Button, Input, Label } from '../ui';
import toast from 'react-hot-toast';

const QueueManager = () => {
  const [extension, setExtension] = useState('');
  const [busy, setBusy] = useState(false);

  const action = async (fn) => {
    if (!extension) {
      toast.error('Extension is required');
      return;
    }
    setBusy(true);
    try {
      const msg = await fn(extension);
      toast.success(typeof msg === 'string' ? msg : 'Success');
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data || 'Operation failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Queue Management</CardTitle>
            <Button asChild>
              <Link to="/callcenter/queue/status">View Queue Status</Link>
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="max-w-md space-y-4">
            <div className="space-y-2">
              <Label htmlFor="ext">Agent Extension</Label>
              <Input
                id="ext"
                placeholder="e.g., 1001"
                value={extension}
                onChange={(e) => setExtension(e.target.value)}
              />
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <div className="flex gap-3">
            <Button disabled={busy} onClick={() => action(callcenterService.addToQueue)}>
              {busy ? 'Processing...' : 'Add to Queue'}
            </Button>
            <Button variant="secondary" disabled={busy} onClick={() => action(callcenterService.removeFromQueue)}>
              {busy ? 'Processing...' : 'Remove from Queue'}
            </Button>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};

export default QueueManager;

